module.exports = __webpack_public_path__ + "img/SKLB-Alumnos.a77fe90e.png";